<template>
  <div class="sustainability-rotator">
    <transition-group :name="`slide-${direction}`" mode="out-in">
      <div
        v-if="active === 0"
        key="rotator-bg-0"
        class="sustainability-rotator-bg"
        :style="{ backgroundImage: `url(${require('../../assets/img/sustainability/sustainability/eco.jpg')})` }"
      ></div>
      <div
        v-else-if="active === 1"
        key="rotator-bg-1"
        class="sustainability-rotator-bg"
        :style="{ backgroundImage: `url(${require('../../assets/img/sustainability/sustainability/soc.jpg')})` }"
      ></div>
      <div
        v-else-if="active === 2"
        key="rotator-bg-2"
        class="sustainability-rotator-bg"
        :style="{ backgroundImage: `url(${require('../../assets/img/sustainability/sustainability/health.jpg')})` }"
      ></div>
    </transition-group>
    <div class="rotator-svg-wrapper">
      <!-- CIRCLE LINES -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 535.85 597.44"
        width="535.85px"
        height="597.44px"
        :style="{ transform: `rotate(${getDegrees}deg)`}"
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path
              class="green"
              :class="{ 'active' : active === 0 }"
              d="M50.34,334.7l1.93-.61-.21-1.16a219.18,219.18,0,0,1,3.45-87.41A216.13,216.13,0,0,1,91.2,169.28,217.49,217.49,0,0,1,185.86,96c-.11-.67-.21-1.35-.3-2A219.31,219.31,0,0,0,50.09,333.25C50.17,333.73,50.26,334.21,50.34,334.7Z"
            ></path>
            <path
              class="green"
              :class="{ 'active' : active === 0 }"
              d="M185.86,102.18l2.5-7.75a2,2,0,0,0,0-.24,1.19,1.19,0,0,0-.41-1,1.09,1.09,0,0,0-.41-.23l-7.75-2.49a1.18,1.18,0,1,0-.72,2.24l6.62,2.14-2.13,6.62a1.17,1.17,0,0,0,.08.9,1.14,1.14,0,0,0,.68.59A1.18,1.18,0,0,0,185.86,102.18Z"
            ></path>
            <path
              class="orange"
              :class="{ 'active' : active === 1 }"
              d="M32.51,342.75a237.61,237.61,0,0,1-4.11-54.53C32.32,188.86,97,106,185.09,73.88c.07-.78.14-1.56.23-2.34A240.56,240.56,0,0,0,30.64,343.89C31.26,343.5,31.88,343.13,32.51,342.75Z"
            ></path>
            <path
              class="orange"
              :class="{ 'active' : active === 1 }"
              d="M24.33,340.89l6.83,4.43.22.11a1.2,1.2,0,0,0,1.09-.12,1.19,1.19,0,0,0,.33-.34l4.43-6.83a1.2,1.2,0,0,0-.35-1.64,1.24,1.24,0,0,0-.89-.16,1.18,1.18,0,0,0-.75.51l-3.78,5.84-5.84-3.78a1.15,1.15,0,0,0-.89-.16,1.17,1.17,0,0,0-.4,2.14Z"
            ></path>
            <path
              class="orange"
              :class="{ 'active' : active === 1 }"
              d="M406.46,469.41,405,468l-.92.75a217.26,217.26,0,0,1-272.1-.2l-1.62,1.26a219.58,219.58,0,0,0,154,48.18,217,217,0,0,0,42.4-7.4,221,221,0,0,0,78.55-40.28C405.7,470,406.08,469.72,406.46,469.41Z"
            ></path>
            <path
              class="orange"
              :class="{ 'active' : active === 1 }"
              d="M137.36,465.54l-8,1.63-.23.07a1.17,1.17,0,0,0-.69.85,1.24,1.24,0,0,0,0,.47l1.63,8a1.18,1.18,0,0,0,2.15.41,1.22,1.22,0,0,0,.17-.88l-1.4-6.82,6.82-1.4a1.17,1.17,0,0,0,.75-.5,1.15,1.15,0,0,0,.17-.89A1.18,1.18,0,0,0,137.36,465.54Z"
            ></path>
            <path
              class="blue"
              :class="{ 'active' : active === 2 }"
              d="M422.23,481a237.83,237.83,0,0,1-45.48,30.37c-88.49,45.37-192.43,29.77-263.66-31.25-.72.33-1.44.65-2.16.95a240.49,240.49,0,0,0,266.73,32.08,242,242,0,0,0,46.48-31.07C423.5,481.71,422.87,481.35,422.23,481Z"
            ></path>
            <path
              class="blue"
              :class="{ 'active' : active === 2 }"
              d="M424.63,489l.5-8.12a1.93,1.93,0,0,0,0-.24,1.17,1.17,0,0,0-1.1-1l-8.12-.5a1.18,1.18,0,0,0-1,2,1.2,1.2,0,0,0,.81.39l6.95.43-.43,6.95a1.16,1.16,0,0,0,.29.85,1.18,1.18,0,0,0,2.07-.71Z"
            ></path>
            <path
              class="blue"
              :class="{ 'active' : active === 2 }"
              d="M348.44,92.84c-.15.66-.31,1.31-.48,2l1.11.43a217.23,217.23,0,0,1,134,236.8l1.9.79A219.33,219.33,0,0,0,349.81,93.37Z"
            ></path>
            <path
              class="blue"
              :class="{ 'active' : active === 2 }"
              d="M477.78,328.85l5.36,6.13a.91.91,0,0,0,.17.17,1.17,1.17,0,0,0,1.08.18,1.27,1.27,0,0,0,.41-.23l6.14-5.36a1.18,1.18,0,0,0-.7-2.06,1.21,1.21,0,0,0-.86.28l-5.24,4.58-4.58-5.24a1.15,1.15,0,0,0-.81-.4,1.13,1.13,0,0,0-.85.28A1.18,1.18,0,0,0,477.78,328.85Z"
            ></path>
            <path
              class="green"
              :class="{ 'active' : active === 0 }"
              d="M350.73,73.41A237.21,237.21,0,0,1,399.57,98c83.11,54.6,120.81,152.72,102.85,244.78q1,.69,1.89,1.41a240.55,240.55,0,0,0-153.59-273C350.73,72,350.74,72.68,350.73,73.41Z"
            ></path>
            <path
              class="green"
              :class="{ 'active' : active === 0 }"
              d="M356.54,67.36l-7.31,3.57-.21.13a1.15,1.15,0,0,0-.45,1,1.06,1.06,0,0,0,.11.45l3.57,7.32a1.19,1.19,0,0,0,1.58.54,1.12,1.12,0,0,0,.6-.68,1.18,1.18,0,0,0-.05-.9l-3.05-6.25,6.25-3.06a1.19,1.19,0,0,0,.6-.67,1.16,1.16,0,0,0-.06-.91A1.18,1.18,0,0,0,356.54,67.36Z"
            ></path>
          </g>
        </g>
      </svg>
      <!-- TRIANGLES -->
      <div class="svg-triangles">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 535.85 597.44"
          width="535.85px"
          height="597.44px"
          :style="{ transform: `rotate(${ getDegrees * -2 }deg)`}"
        >
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <polygon
                class="green"
                :class="{ 'active' : active === 0 }"
                :transform="`rotate(${getDegrees * 3}, 267.75, 152.31999969482422)`"
                points="267.75 141 287.75 141 277.75 158.32 267.75 175.64 257.75 158.32 247.75 141 267.75 141"
              ></polygon>
              <polygon
                class="orange"
                :class="{ 'active' : active === 1 }"
                :transform="`rotate(${getDegrees * 3}, 140.9900016784668, 371.2149963378906)`"
                points="131.02 377.25 120.99 359.94 140.99 359.91 160.99 359.88 151.02 377.21 141.04 394.55 131.02 377.25"
              ></polygon>
              <polygon
                class="blue"
                :class="{ 'active' : active === 2 }"
                :transform="`rotate(${getDegrees * 3}, 394.75, 369.7149963378906)`"
                points="404.79 376.72 394.83 394.06 384.79 376.76 374.75 359.47 394.75 359.42 414.75 359.37 404.79 376.72"
              ></polygon>
            </g>
          </g>
        </svg>
      </div>
      <div class="svg-circles">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 535.85 597.44"
          width="535.85px"
          height="597.44px"
          :style="{ transform: `rotate(${getDegrees}deg)`}"
        >
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <circle
                class="circle blue"
                :class="{ 'active' : active === 2 }"
                cx="470.85"
                cy="415.12"
                r="64.99"
                @click="changeActive(2)"
              ></circle>
              <circle
                class="circle orange"
                :class="{ 'active' : active === 1 }"
                cx="65"
                cy="415.15"
                r="64.99"
                @click="changeActive(1)"
              ></circle>
              <circle
                class="circle green"
                :class="{ 'active' : active === 0 }"
                cx="267.75"
                cy="65"
                r="65"
                @click="changeActive(0)"
              ></circle>
              <circle class="cls-1" cx="267.75" cy="532.44" r="65"></circle>
              <text
                class="text"
                :transform="`translate(258 45) rotate(${getDegrees * -1} 10 20)`"
                @click="changeActive(0)"
              >
                <tspan
                  class="cls-3"
                  x="10"
                  dy="15"
                  text-anchor="middle"
                  alignment-baseline="middle"
                >{{ $t('sustainability-rotator-1') }}</tspan>
                <tspan
                  class="cls-3"
                  x="10"
                  dy="15"
                  text-anchor="middle"
                  alignment-baseline="middle"
                >{{ $t('sustainability-rotator-2') }}</tspan>
              </text>
              <text
                class="text"
                :transform="`translate(54 395) rotate(${getDegrees * -1} 10 20)`"
                @click="changeActive(1)"
              >
                <tspan
                  class="cls-3"
                  x="10"
                  dy="15"
                  text-anchor="middle"
                  alignment-baseline="middle"
                >{{ $t('sustainability-rotator-3') }}</tspan>
                <tspan
                  class="cls-3"
                  x="10"
                  dy="15"
                  text-anchor="middle"
                  alignment-baseline="middle"
                >{{ $t('sustainability-rotator-4') }}</tspan>
              </text>
              <text
                class="text"
                :transform="`translate(460 395) rotate(${getDegrees * -1} 10 20)`"
                @click="changeActive(2)"
              >
                <tspan
                  class="cls-3"
                  x="10"
                  dy="15"
                  text-anchor="middle"
                  alignment-baseline="middle"
                >{{ $t('sustainability-rotator-5') }}</tspan>
                <tspan
                  class="cls-3"
                  x="10"
                  dy="15"
                  text-anchor="middle"
                  alignment-baseline="middle"
                >{{ $t('sustainability-rotator-6') }}</tspan>
              </text>
            </g>
          </g>
        </svg>
      </div>
      <div class="svg-text">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 535.85 597.44"
          width="535.85px"
          height="597.44px"
        >
          <transition name="fade" mode="out-in">
            <text
              class="titles green-text"
              x="50%"
              y="50%"
              stroke="#fff"
              dy=".3em"
              text-anchor="middle"
              alignment-baseline="middle"
              key="rotator-text-1"
              v-if="active === 0"
            >
              <tspan
                x="50%"
                y="43%"
                text-anchor="middle"
                alignment-baseline="middle"
                dy=".3em"
              >{{ $t('sustainability-rotator-7') }}</tspan>
              <tspan
                x="50%"
                y="48%"
                text-anchor="middle"
                alignment-baseline="middle"
                dy=".3em"
              >{{ $t('sustainability-rotator-8') }}</tspan>
              <tspan
                x="50%"
                y="53%"
                text-anchor="middle"
                alignment-baseline="middle"
                dy=".3em"
              >{{ $t('sustainability-rotator-9') }}</tspan>
            </text>
            <text
              class="titles orange-text"
              x="50%"
              y="50%"
              stroke="#fff"
              dy=".3em"
              text-anchor="middle"
              alignment-baseline="middle"
              key="rotator-text-2"
              v-else-if="active === 1"
            >
              <tspan
                x="50%"
                y="43%"
                text-anchor="middle"
                alignment-baseline="middle"
                dy=".3em"
              >{{ $t('sustainability-rotator-10') }}</tspan>
              <tspan
                x="50%"
                y="48%"
                text-anchor="middle"
                alignment-baseline="middle"
                dy=".3em"
              >{{ $t('sustainability-rotator-11') }}</tspan>
              <tspan
                x="50%"
                y="53%"
                text-anchor="middle"
                alignment-baseline="middle"
                dy=".3em"
              >{{ $t('sustainability-rotator-12') }}</tspan>
            </text>
            <text
              class="titles blue-text"
              x="50%"
              y="50%"
              stroke="#fff"
              dy=".3em"
              text-anchor="middle"
              alignment-baseline="middle"
              key="rotator-text-3"
              v-else-if="active === 2"
            >
              <tspan
                x="50%"
                y="43%"
                text-anchor="middle"
                alignment-baseline="middle"
                dy=".3em"
              >{{ $t('sustainability-rotator-13') }}</tspan>
              <tspan
                x="50%"
                y="48%"
                text-anchor="middle"
                alignment-baseline="middle"
                dy=".3em"
              >{{ $t('sustainability-rotator-14') }}</tspan>
              <tspan
                x="50%"
                y="53%"
                text-anchor="middle"
                alignment-baseline="middle"
                dy=".3em"
              >{{ $t('sustainability-rotator-15') }}</tspan>
            </text>
          </transition>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deg: 120,
      active: 0,
      rotation: null,
      direction: "top"
    };
  },
  computed: {
    getDegrees() {
      return this.deg * this.active;
    }
  },
  methods: {
    changeActive(n) {
      this.stopRotating();
      if (n < this.active) {
        this.direction = "top";
      } else {
        this.direction = "bottom";
      }
      this.active = n;
      this.startRotating();
    },
    startRotating() {
      this.rotation = setInterval(() => {
        if (this.active < 2) {
          this.direction = "top";
          this.active++;
        } else {
          this.direction = "bottom";
          this.active = 0;
        }
      }, 8000);
    },
    stopRotating() {
      clearInterval(this.rotation);
    }
  },
  mounted() {
    // GET CENTER POINTS OF SVG ELEMENT
    // const el = document.getElementById("test").getBBox();
    // console.log(el.x + el.width / 2, el.y + el.height / 2);
    this.startRotating();
  },
  destroyed() {
    this.stopRotating();
  }
};
</script>

<style lang="scss" scoped>
.sustainability-rotator {
  overflow: hidden;
  position: relative;
  .sustainability-rotator-bg {
    background-size: cover;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }
  .rotator-svg-wrapper {
    @extend %flex-center;
    background-color: rgba(10, 31, 84, 0.8);
    height: 100%;
    padding: 50px;
    width: 100%;
    position: relative;
    z-index: 1;
    svg {
      @include transition(all 1s $mainCubic);
      z-index: 1;
      polygon {
        @include transition(all 1s $mainCubic);
      }
      text {
        @include transition(all 1s $mainCubic);
      }
      tspan {
        @include transition(all 1s $mainCubic);
      }
      .cls-1 {
        fill: none;
      }
      .text,
      .titles {
        cursor: pointer;
        font-size: 17px;
        font-weight: 700;
        fill: #fff;
        font-family: "Rubik";
      }
      .titles {
        font-size: 19px;
        font-weight: 500;
      }
      .green {
        fill: #3c8d1e;
        opacity: 0.5;
        @include transition(all 1s $mainCubic);
      }
      .orange {
        fill: #f58220;
        opacity: 0.5;
        @include transition(all 1s $mainCubic);
      }
      .blue {
        fill: #2aacef;
        opacity: 0.5;
        @include transition(all 1s $mainCubic);
      }
      .green-text {
        fill: #8dd166;
        stroke: #8dd166;
      }
      .orange-text {
        fill: #f58220;
        stroke: #f58220;
      }
      .blue-text {
        fill: #2aacef;
        stroke: #2aacef;
      }
      .circle {
        cursor: pointer;
      }
      .active {
        opacity: 1;
      }
    }
  }
  .svg-triangles,
  .svg-circles,
  .svg-text {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .svg-circles {
    z-index: 1;
  }
}
@media screen and (max-width: 1600px) {
  .sustainability-rotator {
    .rotator-svg-wrapper {
      svg {
        .text,
        .titles {
          font-size: 14px;
  
        }
        .titles {
          font-size: 16px;
        }
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  
}
</style>
